import defaultCompanyLogo from '../assets/images/CF.png';

const getBuildEnv = (key, fallback = '') => process.env[key] || fallback;
const getBooleanBuildEnv = (key, fallback = false) => {
  const value = process.env[key];
  if (value === undefined || value === '') return fallback;
  return String(value).toLowerCase() === 'true';
};

const ENV_BASE_URL = getBuildEnv(
  'REACT_APP_ENV_BASE_URL',
  'https://viu9hqj9k3.execute-api.us-east-1.amazonaws.com/api/v1/'
);
const ENV_BASE_URL_V2 = getBuildEnv(
  'REACT_APP_ENV_BASE_URL_V2',
  'https://viu9hqj9k3.execute-api.us-east-1.amazonaws.com/api/v2/'
);
const ENV_NODE_LAMBDA = getBuildEnv(
  'REACT_APP_ENV_NODE_LAMBDA',
  'https://1d1x86mdmd.execute-api.us-east-1.amazonaws.com/dev/'
);
const ENV_IMAGE_URL = getBuildEnv(
  'REACT_APP_ENV_IMAGE_URL',
  'https://circadn5c3ef53d0ecb465fbc5b20293d2e9f5a134820-circadn.s3.amazonaws.com/public/'
);
const ENV_BASE_URL_WEB = getBuildEnv(
  'REACT_APP_ENV_BASE_URL_WEB',
  'https://portaldev1.coachfirst.com/api/v1/'
);

export const BASE_URL = ENV_BASE_URL;
export const BASE_URL_V2 = ENV_BASE_URL_V2;
export const BASE_URL_WEB = ENV_BASE_URL_WEB;

export const NODE_LAMBDA = ENV_NODE_LAMBDA;
export const IMAGE_URL = ENV_IMAGE_URL;
export const DEFAULT_COMPANY_LOGO = defaultCompanyLogo;
export const INVOICES_ENABLED = getBooleanBuildEnv('REACT_APP_INVOICES_ENABLED', true);

export const PRIMARY_COLOR = '#c82638';

export const TNC_PRIVACY = 'https://www.coachfirst.com/docs/privacypolicy.pdf';
export const TNC_TERMS = 'https://www.coachfirst.com/docs/terms.pdf';
export const CLIENT_SUPPORT = 'https://coachfirst.tawk.help/article/the-client-guide-to-coachfirst';
//https://circadnwebsite.s3.us-east-1.amazonaws.com/images/CF.png
